import { environment } from '@/environments/environment'
export default [
  { name: 'getCountriesCollection', url: `${environment.newyorkApiUrl}//v3/coverage/countries/collections`, method: 'get' },
  { name: 'getCarriersCollection', url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/collections/carriers`, method: 'get' },
  { name: 'getCollectionOnDelivery', url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/collections`, method: 'get' },
  { name: 'postCollectionOnDelivery', url: `${environment.newyorkApiUrl}/v3/coverage/collections`, method: 'post', headers: {'Content-Type': 'multipart/form-data'}}
]
